import axios from 'axios';
import EnvironmentConfig from '../common/EnvironmentConfig';

const envConfig = EnvironmentConfig.getConfig();
const catPortal = axios.create({
  baseURL: envConfig.portalEndpoint,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  timeout: 120000,
});

const mplService = axios.create({
  baseURL: envConfig.mplServiceEndpoint,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  timeout: 120000,
});

export { catPortal, mplService };
